module.exports = __webpack_public_path__ + "static/john-c07b6ed7019fee7533c7adc02c78e7c5.png";